import type { ConditionOperator, ViewFilterModifier } from "@regrello/graphql-api";

/** A type that describes the ways in which a __multi-select__ value can be filtered. */
export type RegrelloFilterDefinition_MultiSelectValue<T> = {
  type: "multiSelect";
  options:
    | {
        type: "default";
        values: Array<{ id: number; label: string; value: T }>;
      }
    | { type: "party" }
    | { type: "tag" }
    | { type: "openTaskName" };
  filter:
    | { operator: "CONTAINS_ANY_OF"; values: T[]; modifier?: ViewFilterModifier }
    | { operator: "CONTAINS_ALL_OF"; values: T[]; modifier?: ViewFilterModifier }
    | { operator: "CONTAINS_NONE_OF"; values: T[]; modifier?: ViewFilterModifier };
};

export const regrelloFilterOperators_MultiSelectValue: Record<
  RegrelloFilterDefinition_MultiSelectValue<unknown>["filter"]["operator"],
  true
> = {
  CONTAINS_ALL_OF: true,
  CONTAINS_ANY_OF: true,
  CONTAINS_NONE_OF: true,
};

export function getRegrelloDefaultFilterDefinitionMultiSelectValue<T>(
  options?: RegrelloFilterDefinition_MultiSelectValue<T>["options"],
  modifier?: ViewFilterModifier,
): RegrelloFilterDefinition_MultiSelectValue<T> {
  return {
    type: "multiSelect",
    options: options ?? { type: "default", values: [] },
    filter: {
      operator: "CONTAINS_ANY_OF",
      values: [] as T[],
      modifier: modifier,
    },
  };
}
export function getRegrelloFilterDefinitionMultiSelectValue(
  operator: ConditionOperator,
  values: string[],
  allowedValues: Array<{
    id: number;
    label: string;
    value: string;
  }>,
): RegrelloFilterDefinition_MultiSelectValue<unknown> | undefined {
  switch (operator) {
    case "CONTAINS_ALL_OF":
    case "CONTAINS_NONE_OF":
    case "CONTAINS_ANY_OF":
      return {
        type: "multiSelect",
        options: {
          type: "default",
          values: allowedValues,
        },
        filter: {
          operator: operator,
          values: values.map((value, index) => {
            return { id: index, label: value, value: value };
          }),
        },
      };
    default:
      console.warn("Unrecognized operator for multiselect filter:", operator);
      return undefined;
  }
}
